class CardReveal extends HTMLElement {
  expanded = false;
  show_count = 4;
  items = [];
  button = null;
  buttonText = null;
  controlsContainer = null;
  delayTime = 100;
  timer = 0;

  constructor() {
    super();

    if (this.getAttribute('data-delay')) this.delayTime = this.getAttribute('data-delay') * 1;
    // TODO: Need to add motion check here

    this.setAttribute('data-ready', true);

    this.show_count = this.getAttribute('data-count') * 1;

    this.button = this.querySelector('[data-card-reveal]');
    this.items = [...this.querySelectorAll('.card-reveal__item')];
    this.controlsContainer = this.querySelector('.card-reveal__controls');

    if (this.button) this.buttonText = this.button.querySelector('.button__text');

    this._onButtonClick = this.onButtonClick.bind(this);

    this.setupItems();
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.button.addEventListener('click', this._onButtonClick);
  }

  removeEventListeners() {
    this.button.removeEventListener('click', this._onButtonClick);
  }

  setupItems() {
    this.setAttribute('data-state', 'collapsed');

    if (this.show_count >= this.items.length) {
      this.expanded = true;
      this.button.setAttribute('aria-expanded', true);
      this.controlsContainer.setAttribute('hidden', '');
      this.setAttribute('data-state', 'expanded');
      return;
    }

    this.items.forEach((item, index) => {
      if (!this.expanded && index >= this.show_count) {
        item.setAttribute('hidden', '');
      }
    });
  }

  updateItems() {
    clearTimeout(this.timer);
    let itemList = this.expanded ? this.items : [...this.items].reverse();

    itemList.some((item, index) => {
      let testIndex = this.items.indexOf(item);
      let currentStateHidden = item.hasAttribute('hidden');
      let targetStateHidden = !this.expanded && testIndex >= this.show_count;

      if (currentStateHidden !== targetStateHidden) {
        if (targetStateHidden) item.setAttribute('hidden', '');
        else item.removeAttribute('hidden');

        if (this.expanded && index < itemList.length - 1) {
          this.timer = setTimeout(() => this.updateItems(), this.delayTime);
          return true;
        }
      }
    });
  }

  onButtonClick() {
    this.expanded = !this.expanded;
    this.button.setAttribute('aria-expanded', this.expanded);

    if (this.expanded) {
      this.buttonText.textContent = 'Show Less';
    } else {
      this.buttonText.textContent = 'Show More';
    }

    this.setAttribute('data-state', this.expanded ? 'expanded' : 'collapsed');

    this.updateItems();
  }
}

customElements.define('card-reveal', CardReveal);
